import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "v1-providers__amount-label" }
const _hoisted_3 = { class: "v1-providers__amount-value" }
const _hoisted_4 = ["data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: "v1-providers__amount",
    "data-testid": _ctx.testId
  }, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.amount), 1),
    (_ctx.nextPayment)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "v1-providers__next-payment",
          "data-testid": _ctx.nextPaymentTestId
        }, _toDisplayString(_ctx.nextPayment), 9, _hoisted_4))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}